import { render, staticRenderFns } from "./SearchResult.vue?vue&type=template&id=389b10e1&scoped=true"
import script from "./SearchResult.vue?vue&type=script&lang=js"
export * from "./SearchResult.vue?vue&type=script&lang=js"
import style0 from "./SearchResult.vue?vue&type=style&index=0&id=389b10e1&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389b10e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('389b10e1')) {
      api.createRecord('389b10e1', component.options)
    } else {
      api.reload('389b10e1', component.options)
    }
    module.hot.accept("./SearchResult.vue?vue&type=template&id=389b10e1&scoped=true", function () {
      api.rerender('389b10e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/jornalPayment/SearchResult.vue"
export default component.exports